// import ReservePrint from './ReservePrint';

export default {
  // component: ReservePrint,
  component: load(() => import(/* webpackChunkName: "Feed-ReservePrint" */ './ReservePrint')),
  priority: 10,
  permissions: ['UserPaymentCheckPrintMenu'],
  name: app.translate('routes.home.feed.ReservePrint User'),
  icon: 'account',
  drawer: false,
};


